module.exports = __webpack_public_path__ + "img/accurate.1bdd02d8.png";